import React from 'react';
import Profile from '../../components/Profile/index'

function index() {
  return (
    <>
        <Profile />
    </>
  )
}

export default index